module.exports = __webpack_public_path__ + "img/s13-slogan.530f392e.png";